import { observer } from 'mobx-react-lite'
import { Link, Outlet } from 'react-router-dom'
import { PageScroll } from 'app/components/layout/PageScroll'
import { Button } from 'app/components/ui/button'
import { PageHeader } from 'app/components/ui/page-header'
import type { TabType } from 'app/components/Tabs'

export type LocationSettingsViewShadcnComponentProps = {
  title: string
  tabs: TabType[]
  canCreateLocation: boolean
}

export const LocationSettingsViewShadcnComponent = observer(function LocationSettingsViewShadcnComponent({
  title,
  tabs,
  canCreateLocation,
}: LocationSettingsViewShadcnComponentProps) {
  return (
    <PageScroll
      contentClassName="mt-8 flex flex-col"
      header={
        <PageHeader
          title={title}
          tabs={tabs}
          primaryButtonSlot={
            canCreateLocation ? (
              <Link to="/settings/location-settings/new">
                <Button>+ Add Location</Button>
              </Link>
            ) : undefined
          }
        />
      }
    >
      <Outlet />
    </PageScroll>
  )
})
